export const topicList = [
  {
    id: 't1',
    title: '新生代歌手凭什么横扫音乐盛典？',
    summary: '从现场表现到作品创作，这届音乐盛典让更多人看到了年轻音乐人的实力与野心，也引发了关于“流量与实力”的新一轮讨论。',
    heat: 98200,
    participants: 12400,
    tags: ['明星动态', '音乐盛典'],
    publishedAt: '2026-10-11',
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20award%20show%20stage%20with%20warm%20orange%20spotlights%20and%20confetti%2C%20editorial%20entertainment%20photography%2C%20clean%20vibrant%20background&width=800&height=600&seq=topic-cover-01&orientation=landscape',
  },
  {
    id: 't2',
    title: '悬疑剧为什么越来越“慢”了？',
    summary: '不靠强反转、不堆砌噱头，一批以细节和氛围见长的悬疑剧正在改变观众的审美，也重新定义了这类题材的节奏。',
    heat: 86300,
    participants: 9800,
    tags: ['影评解读', '电视剧'],
    publishedAt: '2026-10-10',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20foggy%20city%20street%20at%20night%20with%20warm%20lamp%20glow%2C%20cinematic%20editorial%20photography%2C%20clean%20dramatic%20background&width=800&height=600&seq=topic-cover-02&orientation=landscape',
  },
  {
    id: 't3',
    title: '短视频翻跳挑战，为什么总能一夜爆红？',
    summary: '简洁的编舞加上低门槛的参与设计，让一首歌的传播不再依赖宣发，而是交给每一个愿意动起来的人。',
    heat: 121500,
    participants: 21300,
    tags: ['社交热点', '明星动态'],
    publishedAt: '2026-10-09',
    cover: 'https://readdy.ai/api/search-image?query=Energetic%20dance%20motion%20with%20warm%20orange%20lights%20and%20blur%2C%20editorial%20concert%20photography%2C%20clean%20vibrant%20background&width=800&height=600&seq=topic-cover-03&orientation=landscape',
  },
  {
    id: 't4',
    title: '古装剧的“质感战”，观众到底在看什么？',
    summary: '从实景搭建到服装道具，越来越多古装作品愿意在细节上下功夫，观众也愿意为这份用心买单。',
    heat: 74500,
    participants: 7600,
    tags: ['影评解读', '影视动态'],
    publishedAt: '2026-10-08',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20warm%20lantern%20glow%20and%20silk%20drapes%2C%20cinematic%20editorial%20photography%2C%20clean%20elegant%20background&width=800&height=600&seq=topic-cover-04&orientation=landscape',
  },
  {
    id: 't5',
    title: '小成本爱情片，凭什么逆袭大档期？',
    summary: '没有大明星、没有宏大场面，一部真诚讲述普通人情感的作品，依然能在竞争激烈的档期里找到自己的观众。',
    heat: 61200,
    participants: 6400,
    tags: ['影评解读', '影视动态'],
    publishedAt: '2026-10-07',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20riverside%20sunset%20with%20warm%20glow%20and%20bokeh%2C%20cinematic%20editorial%20photography%2C%20clean%20cozy%20background&width=800&height=600&seq=topic-cover-05&orientation=landscape',
  },
  {
    id: 't6',
    title: '综艺不再“卷”淘汰，观众想要的是什么？',
    summary: '当竞技与淘汰不再是唯一卖点，越来越多节目开始关注人与人的交流，把温暖和真实感放回舞台中央。',
    heat: 55700,
    participants: 5800,
    tags: ['社交热点', '综艺'],
    publishedAt: '2026-10-06',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20variety%20show%20set%20with%20soft%20orange%20lighting%2C%20editorial%20photography%2C%20clean%20friendly%20background&width=800&height=600&seq=topic-cover-06&orientation=landscape',
  },
  {
    id: 't7',
    title: '明星公益，如何从“话题”走向“常态”？',
    summary: '越来越多的艺人把公益做成长期的行动，而非一次性的曝光。当关注转化为持续的参与，改变才真正开始。',
    heat: 48900,
    participants: 5200,
    tags: ['社交热点', '公益'],
    publishedAt: '2026-10-05',
    cover: 'https://readdy.ai/api/search-image?query=Urban%20park%20tree%20planting%20with%20warm%20sunlight%2C%20documentary%20lifestyle%20photography%2C%20clean%20fresh%20background&width=800&height=600&seq=topic-cover-07&orientation=landscape',
  },
  {
    id: 't8',
    title: '短剧精品化，是风口还是必经之路？',
    summary: '产量激增之后，短剧行业开始思考更长远的答案：只有把内容打磨好，才能让观众留下来。',
    heat: 42300,
    participants: 4100,
    tags: ['行业观察', '短剧'],
    publishedAt: '2026-10-04',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20content%20studio%20with%20warm%20orange%20accent%20lighting%2C%20cameras%20and%20monitors%2C%20editorial%20clean%20minimal%20background&width=800&height=600&seq=topic-cover-08&orientation=landscape',
  },
  {
    id: 't9',
    title: '纪录片出圈，普通人故事为何如此动人？',
    summary: '当镜头愿意慢下来，平凡生活里的坚持与温度，往往比戏剧化的情节更能打动人心。',
    heat: 39800,
    participants: 3700,
    tags: ['影评解读', '纪录片'],
    publishedAt: '2026-10-03',
    cover: 'https://readdy.ai/api/search-image?query=Serene%20mountain%20village%20at%20golden%20hour%2C%20documentary%20editorial%20photography%2C%20clean%20calm%20background&width=800&height=600&seq=topic-cover-09&orientation=landscape',
  },
  {
    id: 't10',
    title: '跨年晚会的“情怀牌”，为何屡试不爽？',
    summary: '几代人的共同记忆被重新唱起，跨越年代的舞台设计，让怀旧与新鲜在同一個夜晚相遇。',
    heat: 36100,
    participants: 3300,
    tags: ['社交热点', '晚会'],
    publishedAt: '2026-10-02',
    cover: 'https://readdy.ai/api/search-image?query=Festive%20celebration%20stage%20with%20warm%20gold%20and%20orange%20lights%2C%20editorial%20concert%20photography%2C%20clean%20elegant%20background&width=800&height=600&seq=topic-cover-10&orientation=landscape',
  },
];